import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-old-subheader-bar',
    templateUrl: './sera-old-subheader-bar.component.html',
    styleUrls: ['./sera-old-subheader-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraOldSubheaderBarComponent {
    @Input()
    titleText: string = '';

    @Input()
    styleClass: string = '';

    @Input()
    showHazardCreatedInCr13Warning: boolean = false;
}
